<script>
import drawer from '@/components/drawer';
import transitionFade from '@/components/transition/fade.vue';
import store from '../../store';
import {forEach, includes, map, findIndex} from 'lodash';

export default {
    data() {
        return {
            windowWidth: '90%',
            isError: false,
            errorMsg: ''
        }
    },
    props: {
        status: {
            type: Boolean
        }
    },
    computed: {
        list() {
            return store.dealerInfo.dealerList;
        },
        checked() {
            let checkedIdList = map(store.form.dealers, item => item.id);
            return checkedIdList;
        }
    },
    methods: {
        change(item) {
            let choosenList = store.form.dealers;
            if (includes(this.checked, item.id)) {
                // 取消选择
                let index = findIndex(choosenList, item);
                choosenList.splice(index, 1);
                this.isError = false;
                this.errorMsg = '';
            } else {
                // 选中逻辑
                if (choosenList.length <3) {
                    choosenList.push(item);
                    this.isError = false;
                    this.errorMsg = '';
                    this.$emit('change', true);
                } else {
                    this.isError = true;
                    this.errorMsg = '您最多可以选择3家4s店';
                }
            }
            this.$emit('update:status', true);
        },
        include(arr, item) {
            return includes(arr, item);
        },
        closeWin() {
            if (this.checked.length > 0 && this.checked.length <= 3) {
                this.isError = false;
                this.errorMsg = '';
                this.$emit('update:status', false)
            } else {
                this.isError = true;
                this.errorMsg = '请选择经销商';
                return false;
            }
        }
    },
    components: {
        drawer,
        transitionFade
    }
}
</script>

<template>
    <drawer 
        :status="status" 
        :width="windowWidth"
        :clickShadowAutoClose="true"
        @update:status="$emit('update:status', $event)"
    > 
        <div class="sidebar-container">
            <div class="header">
                <h4>请选择经销商</h4>
                <span @click="$emit('update:status', false)"></span>
                <transition-fade>
                    <div class="error-wrap">
                        <p class="error" v-if="isError">
                            <i></i>
                            {{errorMsg}}
                        </p>
                    </div>
                </transition-fade>
            </div>
            <div class="content">
                <ul>
                    <li
                        v-for="item in list"
                        :data-id="item.id"
                        @click="change(item)"
                        :key="item.id"
                    >
                        <transition-fade>
                            <i :class="{'checked': include(checked, item.id)}"></i>
                        </transition-fade>
                        <h4>{{item.name}}</h4>
                        <em>{{item.address}}</em>
                    </li>
                </ul>
                <div class="confirm" :class="{'unchoose': checked.length === 0}" @click="closeWin">
                    <h4>确 认</h4>
                </div>
            </div>
        </div>
    </drawer>
</template>

<style lang="stylus" scoped>
.sidebar-container
    display flex
    flex-direction column
    height 100%
    background-color #fff
.header
    position relative
    height 2.13rem
    line-height 2.13rem
    // background linear-gradient(135deg,rgba(255,168,0,1) 0%,rgba(255,60,0,1) 100%)
    // background-color #ff3c00
    h4
        font-size .8rem
        font-weight normal
        color #111E36
        text-align center
    span
        position absolute
        top .5rem
        bottom 0
        left .75rem
        // padding 0 0.64rem
        font-size 0.64rem
        color #111E36
        cursor pointer
        width 1.1rem
        height 1.1rem
        background url('../../../assets/btn_close_black.png') top left no-repeat
        background-size cover
.content
    flex 1
    overflow-x hidden
    overflow-y auto
    ul
        font-size 0.746rem
        padding-bottom 2.5rem
    li
        position relative
        // padding 0.53rem 2.13rem 0.53rem 0.53rem
        padding 0.53rem 0.53rem 0.53rem 2.13rem
        line-height 1.2
        text-align left
        border-bottom 0.053rem solid #eee
        word-break keep-all
        cursor pointer
        h4
            font-size .8rem
            color #111E36
            line-height 2rem
        em
            font-size 0.6rem
            color #666D7F
            font-style normal
            word-wrap break-word
            word-break break-all
    .confirm
        position absolute
        height 2.13rem
        line-height 2.13rem
        background linear-gradient(135deg,rgba(255,168,0,1) 0%,rgba(255,60,0,1) 100%)
        background-color #ff3c00
        bottom 0
        width 100%
        color #ffffff
        text-align center
        font-size 0.8rem
        font-weight normal
        &.unchoose
            background #D3D3D3
    li i
        position absolute
        top 50%
        left 0.6rem
        width 1.1rem
        height 1.1rem
        border-radius:.55rem
        background-color transparent
        transform translate(0, -50%)
        background url('../../../assets/unchosen_icon.png') top left no-repeat
        background-size contain
        &.checked
            background url('../../../assets/chosen_icon.png') top left no-repeat
            background-size contain
.error-wrap
    background #ffffff
    position absolute
    top 1.9rem
    left 0
    width 100%
    z-index 5
    .error
        // margin 0 0.75rem
        padding-top 0.1rem
        background-color #FFECEB
        line-height 1.2rem
        font-size .5rem
        vertical-align middle
        color #F5594E
        i
            width .5rem
            height .5rem
            background url('../../../assets/shape.png') top left no-repeat
            background-size cover
            margin 0.1rem 0.25rem 0 0.5rem
            display inline-block
</style>